import { Component, NgZone, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { TreatmentService } from 'src/app/services/treatment.service';
import { PatientService } from 'src/app/services/patient.service';

declare var Ext: any;

@ManageType('MedicationPanelComponent')
@Component({
  selector: 'app-medication-panel',
  templateUrl: './medication-panel.component.html',
  styleUrls: ['./medication-panel.component.scss']
})
export class MedicationPanelComponent implements OnInit {

  constructor(private patient: PatientService, private ngZone: NgZone,
              public medicationservice: TreatmentService) { }

  ngOnInit(): void {
  }

  newTreatment(): void {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const patient = new Ext.CNPatient(this.patient.patient.id);
        patient.on('itemLoaded', (item) => {
          const prescriptionwindow = new Ext.CNPrescriptionWindow({ patient: item });
          prescriptionwindow.show();
          prescriptionwindow.on('medicationAdded', (treatment) => {
            setTimeout(() => {
              this.reload();
            });
          });
        });
      });
    });
  }

  reload() {
    this.ngZone.run(() => {
      this.medicationservice.reloadAllSubjects();
    });
  }
}
